(ns io.daskul.webapp.widgets.dashboard.layout
  "Pure layout logic for the dashboard page — no React/uix/re-frame deps, so it
   runs under the :node-test unit build.

   API sections carry a :group key. They render top-to-bottom in three groups:
     :live      current-state, no date filter (e.g. Action Items)
     :snapshot  current-state business snapshot, no date filter (e.g. Overview)
     :analytics date-filtered; renders under a date-range selector

   :live and :snapshot are current-state, so they carry no selector. The
   date-range selector rides only with the :analytics block — a role with no
   analytics sections (e.g. branch-admin) therefore never sees a spurious
   selector. Generic: any product can tag sections into these groups.")

(def group-order
  "Dashboard section groups in top-to-bottom render order."
  [:live :snapshot :analytics])

(defn first-load?
  "True only when there is nothing on screen yet — the one time a full-page
   loader is the right thing to show.

   A re-fetch (date range changed, refresh pressed) used to blank the page and
   remount the whole tree, which discarded the custom From/To the user had just
   typed and jumped them back to the top (#749). Content already rendered stays
   rendered while the next payload is in flight."
  [loading? sections]
  (boolean (and loading? (empty? sections))))

(defn group-sections
  "Group dashboard sections by their (keywordized) :group key."
  [sections]
  (group-by #(keyword (:group %)) sections))

(defn section-blocks
  "Render plan for the dashboard body: a vector of
   {:group <kw> :sections [...] :date-selector? <bool>} in `group-order`,
   omitting groups that have no sections. Only the :analytics block carries
   the date-range selector — current-state :live/:snapshot never do.

   `only-groups` (optional) restricts the plan to those groups. One endpoint
   feeds more than one page: the tutorial Analytics page takes :snapshot +
   :analytics and leaves :live to Today, which already owns the same lead and
   billing queues (#729). Nil/empty means every group, as before."
  ([sections] (section-blocks sections nil))
  ([sections only-groups]
   (let [grouped (group-sections sections)
         wanted  (if (seq only-groups) (set only-groups) (set group-order))]
     (->> group-order
          (filter wanted)
          (keep (fn [g]
                  (when-let [ss (seq (get grouped g))]
                    {:group          g
                     :sections       (vec ss)
                     :date-selector? (= g :analytics)})))
          vec))))
